<h1 matDialogTitle>
    {{
        (!!context.data.assignment
            ? 'folders_edit_assigned_user_title'
            : 'folders_assign_user_title') | translate
    }}
</h1>
<form [formGroup]="form"
      (submit)="onSubmit()">
    <ng-container *ngLet="{
                    loading: loading$ | async,
                    loadingRoles: loadingRoles$ | async,
                    selectedUser: selectedUser$ | async
                } as state">
        <mat-dialog-content>
            <mat-form-field *ngIf="isLocalUser; else adUser">
                <ui-suggest [placeholder]="'folders_assign_user_select_user' | translate"
                            [defaultValue]="'folders_assign_user_search' | translate"
                            [readonly]="!!context.data.assignment"
                            [clearable]="false"
                            [required]="true"
                            [searchSourceFactory]="userSearchFactory"
                            [displayCount]="5"
                            (selected)="onUserSelected($event?.id)"
                            formControlName="user"
                            data-cy="folder-user">
                </ui-suggest>
            </mat-form-field>
            <ng-template #adUser>
                <ui-ad-search (selected)="onUserSelected($event)"></ui-ad-search>
            </ng-template>

            <ui-card-info *ngIf="this.form.get('user').hasError('alreadyAssigned') ||
                                this.form.get(UserGroupField.UserName).hasError('alreadyAssigned'); else rolesSection"
                          type="error">

                <ng-container *ngIf="isInheritingRolesFromTenant; else editableRoles">
                    <span translate>folders_assign_existing_user_warning</span>
                </ng-container>

                <ng-template #editableRoles>
                    <span translate>folders_assign_existing_user_warning</span>
                    <button (click)="switchToEdit()"
                            mat-button
                            type="button"
                            color="primary"
                            data-cy="edit-existing-user">{{ 'folders_assign_existing_user_edit' | translate }}</button>
                </ng-template>

            </ui-card-info>

            <ng-template #rolesSection>
                <ng-container *uiContentLoading="state.loadingRoles; diameter: 40">

                    <div *ngIf="isInheritingRolesFromTenant; else selectRoles"
                         class="user-roles-info-container">
                        <ng-container *ngIf="!!state.selectedUser">
                            <ng-container *ngIf="!!state.selectedUser.rolesList.length; else noRolesAssigned">
                                <div class="roles-label"
                                     translate>{{
                                    state.selectedUser.type === UserType.DirectoryGroup
                                    ? 'folders_assign_user_roles_for_group_above'
                                    : 'folders_assign_user_roles_for_user_above'
                            }}</div>
                                <div data-cy="user-roles-text">
                                    {{ state.selectedUser.rolesList.join(', ') }}
                                </div>
                            </ng-container>

                            <ng-template #noRolesAssigned>
                                <span translate>{{
                                state.selectedUser.type === UserType.DirectoryGroup
                                    ? 'folders_assign_group_no_roles_were_assigned'
                                    : 'folders_assign_user_no_roles_were_assigned'
                            }}</span>
                            </ng-template>
                        </ng-container>
                    </div>

                    <ng-template #selectRoles>
                        <ng-container *ngIf="!!state.selectedUser">
                            <mat-form-field *ngLet="state.selectedUser.type === UserType.DirectoryGroup as isTypeGroup">
                                <ui-suggest [searchable]="true"
                                            [searchSourceFactory]="roleSearchFactory"
                                            [placeholder]="(isTypeGroup
                                                ? 'folders_assign_user_roles_for_group_above'
                                                : 'folders_assign_user_roles_for_user_above') | translate"
                                            [defaultValue]="'user_modal_form_roles_empty' | translate"
                                            [multiple]="true"
                                            [displayCount]="4"
                                            [direction]="isLocalUser ? 'down' : 'up'"
                                            formControlName="rolesList"
                                            data-cy="user-roles">
                                </ui-suggest>
                            </mat-form-field>
                        </ng-container>
                    </ng-template>

                </ng-container>
            </ng-template>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button mat-dialog-close
                    mat-button
                    data-cy="cancel"
                    type="button">
                {{ 'modal_action_cancel' | translate }}
            </button>
            <button [spinnerButtonLoading]="state.loading"
                    [disabled]="state.loading ||
                            state.loadingRoles ||
                            form.pending ||
                            form.invalid"
                    ui-spinner-button
                    mat-flat-button
                    type="submit"
                    data-cy="submit"
                    color="primary">{{ 'folders_assign_assign' | translate }}</button>
        </mat-dialog-actions>
    </ng-container>
</form>
